var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-card"},[_c('img',{staticClass:"project-image",attrs:{"src":_vm.fullImageUrl(_vm.image),"alt":"项目图片"}}),_c('div',{staticClass:"project-info"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('router-link',{staticClass:"detail-btn",attrs:{"to":`/project/${_vm.id}`}},[_vm._v("查看详情")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }